import { handleActions } from 'redux-actions';
import { getApartmentApplications, getApartmentApplicationsFail, getApartmentApplicationsSuccess, getApplication, getApplicationFail, getApplicationSuccess, listApplications, listApplicationsFail, listApplicationsSuccess, updateApplicationSuccess, selectApplications, createApplicationSuccess, createApplication, createApplicationFail, getApartmentLead, getApartmentLeadSuccess, getApartmentLeadFail, getConversation, getConversationSuccess, getConversationFail, updateApplicationPhoneShownByCodeSuccess } from '../actions/applications';
import { Application, PartnerLead } from '../types/applications';
import { ApplicationsState, IndexedApplications } from '../types/states';
import { Action } from './types';
const initialState: ApplicationsState = {
    applications: {},
    createApplication: {
        application: null,
        error: null,
        loading: false
    },
    getApartmentLead: {
        lead: null,
        error: null,
        loading: false
    },
    getConversation: {
        conversation: null,
        error: null,
        loading: false
    },
    isApplicationsLoading: false,
    selectedApplications: []
};
const applicationsReducer = handleActions<ApplicationsState, any>({
    [selectApplications]: (state, { payload: applicationsIds }: Action<string[]>) => ({
        ...state,
        selectedApplications: applicationsIds
    }),
    [getApartmentApplications]: (state) => ({
        ...state,
        isApplicationsLoading: true
    }),
    [getApartmentApplicationsFail]: (state) => ({
        ...state,
        isApplicationsLoading: false
    }),
    [getApartmentApplicationsSuccess]: (state, { payload: { apartmentId, applications } }: Action<{
        apartmentId: string;
        applications: Application[];
    }>) => ({
        ...state,
        applications: {
            ...state.applications,
            [apartmentId]: applications
        },
        isApplicationsLoading: false
    }),
    [getApplication]: (state) => ({
        ...state,
        isApplicationsLoading: true
    }),
    [getApplicationFail]: (state) => ({
        ...state,
        isApplicationsLoading: false
    }),
    [getApplicationSuccess]: (state, { payload: application }: Action<Application>) => {
        if (state.applications[application.apartmentId]) {
            const applicationIndex: number = state.applications[application.apartmentId].findIndex((a: Application) => a.applicationId === application.applicationId);
            const applicationsByApartmentId: Application[] = [
                ...state.applications[application.apartmentId]
            ];
            const index = applicationIndex === -1
                ? state.applications[application.apartmentId].length
                : applicationIndex;
            applicationsByApartmentId[index] = application;
            return {
                ...state,
                applications: {
                    ...state.applications,
                    [application.apartmentId]: [...applicationsByApartmentId]
                },
                isApplicationsLoading: false
            };
        }
        else {
            return {
                ...state,
                applications: {
                    ...state.applications,
                    [application.apartmentId]: [application]
                },
                isApplicationsLoading: false
            };
        }
    },
    [listApplications]: (state) => ({
        ...state,
        isApplicationsLoading: true
    }),
    [listApplicationsFail]: (state) => ({
        ...state,
        isApplicationsLoading: false
    }),
    [listApplicationsSuccess]: (state, { payload: applications }: Action<Application[]>) => {
        const applicationsIndexedByApartmentId = applications.reduce((applicationsAcc: IndexedApplications, application) => {
            if (applicationsAcc[application.apartmentId]) {
                applicationsAcc[application.apartmentId].push(application);
            }
            else {
                applicationsAcc[application.apartmentId] = [application];
            }
            return applicationsAcc;
        }, {});
        return {
            ...state,
            applications: applicationsIndexedByApartmentId,
            isApplicationsLoading: false
        };
    },
    [getApartmentLead]: (state) => ({
        ...state,
        getApartmentLead: {
            ...getApartmentLead,
            error: null,
            loading: true
        }
    }),
    [getApartmentLeadSuccess]: (state, { payload: lead }: Action<PartnerLead>) => ({
        ...state,
        getApartmentLead: {
            lead: lead,
            error: null,
            loading: false
        }
    }),
    [getApartmentLeadFail]: (state, { payload: message }: Action<string>) => ({
        ...state,
        getApartmentLead: {
            ...getApartmentLead,
            error: message,
            loading: false
        }
    }),
    [getConversation]: (state) => ({
        ...state,
        getConversation: {
            ...getConversation,
            error: null,
            loading: true
        }
    }),
    [getConversationSuccess]: (state, { payload: conversation }: Action<any>) => ({
        ...state,
        getConversation: {
            conversation: conversation,
            error: null,
            loading: false
        }
    }),
    [getConversationFail]: (state, { payload: message }: Action<string>) => ({
        ...state,
        getConversation: {
            ...getConversation,
            error: message,
            loading: false
        }
    }),
    [createApplication]: (state) => ({
        ...state,
        createApplication: {
            application: null,
            error: null,
            loading: true
        }
    }),
    [createApplicationSuccess]: (state, { payload: application }: Action<Application>) => ({
        ...state,
        createApplication: {
            application,
            error: null,
            loading: false
        }
    }),
    [createApplicationFail]: (state, { payload: message }: Action<string>) => ({
        ...state,
        createApplication: {
            application: null,
            error: message,
            loading: false
        }
    }),
    [updateApplicationPhoneShownByCodeSuccess]: (state, { payload: application }: Action<Application>) => {
        const tempList = state.applications[application.apartmentId];
        const index = state.applications[application.apartmentId].findIndex((element) => element.applicationId === application.applicationId);
        tempList[index] = application;
        return {
            ...state,
            applications: {
                ...state.applications,
                [application.apartmentId]: tempList
            }
        };
    },
    [updateApplicationSuccess]: (state, { payload: application }: Action<Application>) => {
        if (state.applications[application.apartmentId]) {
            const applicationIndex = state.applications[application.apartmentId].findIndex((a: Application) => a.applicationId === application.applicationId);
            const applicationsByApartmentId = [
                ...state.applications[application.apartmentId]
            ];
            applicationsByApartmentId[applicationIndex] = application;
            return {
                ...state,
                applications: {
                    ...state.applications,
                    [application.apartmentId]: [...applicationsByApartmentId]
                },
                isApplicationsLoading: false
            };
        }
        else {
            return {
                ...state,
                applications: {
                    ...state.applications,
                    [application.apartmentId]: [application]
                },
                isApplicationsLoading: false
            };
        }
    }
}, initialState);
export default applicationsReducer;
